// extracted by mini-css-extract-plugin
export default {"wrapper":"Heatmap_wrapper__PruMS"};